import template from './_table.pug'
import FullTable from 'js/components/full-table/index.js'
import { openModalConfirmRemove } from 'js/services/modals.js'

export default Vue.extend({
  template: template(),
  components: {
    FullTable
  },
  props: {
    callStatusMappings: {
      type: Array,
      required: true
    },
    meta: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showFilters: true, 
      
      showUploadModal: false,
      selectedFile: null,
      isUploading: false,

      filters: {
        typology: '',
        typologyMapping: '',
        level2: null,
        status: null
      }
    }
  },

  computed: {
    filterButtonParams() {
      if (this.showFilters) {
        return { class: 'active', icon: 'angle-up' }
      }
      return { class: '', icon: 'angle-down' }
    },
    
    level2Options() {
      return [
        { id: 'GESTIONABLES', value: 'GESTIONABLES', text: this.t('options.level2.manageable'), label: this.t('options.level2.manageable'), name: this.t('options.level2.manageable') },
        { id: 'NO GESTIONABLES', value: 'NO GESTIONABLES', text: this.t('options.level2.nonManageable'), label: this.t('options.level2.nonManageable'), name: this.t('options.level2.nonManageable') },
        { id: 'SIN TIPIFICAR', value: 'SIN TIPIFICAR', text: this.t('options.level2.untyped'), label: this.t('options.level2.untyped'), name: this.t('options.level2.untyped') }
      ]
    },
    
    statusOptions() {
      return [
        { id: 'CONTACTADO', value: 'CONTACTADO', text: this.t('options.status.contacted'), label: this.t('options.status.contacted'), name: this.t('options.status.contacted') },
        { id: 'NO CONTACTADO', value: 'NO CONTACTADO', text: this.t('options.status.nonContacted'), label: this.t('options.status.nonContacted'), name: this.t('options.status.nonContacted') }
      ]
    }
  },
  methods: {
    t(key, options = {}) {
      return this.$t(`callStatusMappings.index.${key}`, options)
    },

    getData(queryOptions = {}) {
      const activeFilters = queryOptions.filter || this.filters;

      let params = {
        'page[number]': queryOptions.page ? queryOptions.page.number : 1,
        'page[size]': queryOptions.page ? queryOptions.page.size : 20
      };
      
      if (queryOptions.filter && Object.keys(queryOptions.filter).length === 0) {
        this.filters.typology = '';
        this.filters.typologyMapping = '';
        this.filters.level2 = null;
        this.filters.status = null;
      }

      if (activeFilters.typology) params['filter[typology]'] = activeFilters.typology;
      if (activeFilters.typologyMapping) params['filter[typologyMapping]'] = activeFilters.typologyMapping;
      if (activeFilters.level2) params['filter[level2]'] = activeFilters.level2;
      if (activeFilters.status) params['filter[status]'] = activeFilters.status;

      if (queryOptions.order && Object.keys(queryOptions.order).length > 0) {
        params['sort'] = queryOptions.order; 
      }

      this.$emit('load-data', params);
    },

    openConfirmModal(mapping) {
      openModalConfirmRemove(
        this.t('confirmationModal.remove.title'),
        this.t('confirmationModal.remove.body', { typology: mapping.typology }),
        this.t('confirmationModal.remove.okButton')
      ).then(() => this.destroy(mapping))
    },

    destroy(mapping) {
      API.callStatusMappings.destroy(mapping.id).then(() => {
        this.getData();
        this.$notifications.success(this.t('succesfullyDeleted'));
      }).catch(error => {
        console.error("Error al eliminar tipología:", error);
        this.$notifications.error(this.t('errorDeleted'));
      });
    },

    openUploadModal() {
      this.selectedFile = null;
      this.showUploadModal = true;
    },
    
    closeModal() {
      this.showUploadModal = false;
      this.selectedFile = null;
    },
    
    onFileSelected(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.selectedFile = event.target.files[0];
      }
    },
    
    uploadFile() {
      if (!this.selectedFile) return;
      this.isUploading = true;

      API.callStatusMappings.uploadFile(this.selectedFile).then(() => {
        this.$notifications.success(this.t('uploadModal.success'));
        this.closeModal();
        this.getData(); 
      }).catch(error => {
        console.error("Error cargando fichero: ", error);
        this.$notifications.error(this.t('uploadModal.error'));
      }).finally(() => {
        this.isUploading = false;
      });
    }
  }
})